import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../../utils/classNames";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline:
          "text-foreground border-border hover:bg-accent hover:text-accent-foreground",
        muted:
          "border-transparent bg-muted text-muted-foreground hover:bg-muted/80",
        accent:
          "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        success:
          "border-transparent bg-green text-green-foreground hover:bg-green/80",
        warning:
          "border-transparent bg-amber text-amber-foreground hover:bg-amber/80",
        info: "border-transparent bg-blue text-blue-foreground hover:bg-blue/80",
        indigo:
          "border-transparent bg-indigo text-indigo-foreground hover:bg-indigo/80",
        gray: "border-transparent bg-gray text-gray-foreground hover:bg-gray/80",
        green:
          "border-transparent bg-green text-green-foreground hover:bg-green/80",
        blue: "border-transparent bg-blue text-blue-foreground hover:bg-blue/80",
        yellow:
          "border-transparent bg-amber text-amber-foreground hover:bg-amber/80",
        purple:
          "border-transparent bg-indigo text-indigo-foreground hover:bg-indigo/80",
        orange:
          "border-transparent bg-orange text-orange-foreground hover:bg-orange/80",
      },
      size: {
        default: "px-2.5 py-0.1 text-base",
        sm: "px-2 py-0.5 text-sm",
        xs: "px-1.5 py-0.5 text-xs",
        extraSmall: "px-1.5 py-0.5 font_size_11",
        lg: "px-4 py-1.5 text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type TBadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

function Badge({ className, variant, size, ...props }: TBadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
